module.exports = __webpack_public_path__ + "static/img/5.213981d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/9/eng/5.png
// module id = Fc1F
// module chunks = 0